import * as React from "react";
import { forwardRef } from "react";
const SvgRadioSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7, style: {
  fill: "var(--neutral-text)"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 3, style: {
  fill: "var(--neutral-background-base)"
} }));
const ForwardRef = forwardRef(SvgRadioSelected);
export { ForwardRef as ReactComponent };
